export async function getArchitecture() {
  try {
    // @ts-ignore
    return await navigator.userAgentData?.getHighEntropyValues(['architecture', 'bitness']);
  } catch (error) {
    return {};
  }
}
